import React from 'react';
import { Box, TextField, FormControlLabel, Checkbox, Alert, Typography } from '@mui/material';

import { MethodEditorProps } from '../types';

export const DebugEditor: React.FC<MethodEditorProps> = ({ payload, onChange }) => (
  <Box>
    <TextField
      fullWidth
      value={payload?.message || 'Impact AI Context Debug'}
      onChange={(e) => onChange({ ...payload, message: e.target.value })}
      label="Debug Message"
      placeholder="Impact AI Context Debug"
      helperText="Custom message to identify this debug output in console"
      margin="normal"
    />
    <FormControlLabel
      control={
        <Checkbox
          checked={payload?.includeTimestamp !== false}
          onChange={(e) => onChange({ ...payload, includeTimestamp: e.target.checked })}
        />
      }
      label="Include timestamp"
      sx={{ mt: 1, mb: 2 }}
    />
    <Alert severity="info" sx={{ mt: 2 }}>
      <Typography variant="body2">
        <strong>Purpose:</strong> Dumps the entire Impact AI context to browser console
        <br />
        <strong>Output:</strong> Formatted console logs with context keys, values, and JSON
        <br />
        <strong>Usage:</strong> Open browser dev tools (F12) → Console tab to see output
        <br />
        <strong>Features:</strong> Grouped output, individual key inspection, copy-paste JSON
      </Typography>
    </Alert>
  </Box>
);
